var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTokenAiri = function SvgIconTokenAiri(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#icon-token-airi_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.825.213a10.4 10.4 0 0 0-4.21 1.457l2.518.596zM5.886 3.778 7.13 2.267 4.614 1.67H4.61zM5.886 3.778 4.609 1.67v.002l-.516 2.449z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.609 1.672a10.05 10.05 0 0 0-3.082 2.94l2.566-.494z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.735 5.829.357-1.708-2.563.49zM7.13 2.266l1.694.402V.213zM0 8.642h2.57l-.418-1.753z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.735 5.83 1.53 4.611l.623 2.408zM1.53 4.612A9.4 9.4 0 0 0 0 8.642L2.15 7.02zM7.13 2.267l-1.244 1.51a7.75 7.75 0 0 1 2.939-1.109zM5.886 3.778l-1.788.34-.362 1.709a7.5 7.5 0 0 1 2.15-2.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.736 5.829 2.154 7.023l.418 1.621a7 7 0 0 1 1.164-2.815M0 10.893a9.34 9.34 0 0 0 1.525 4.023l.625-2.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.73 13.701-1.578-1.189-.628 2.404zM1.53 14.916a10.05 10.05 0 0 0 3.076 2.944l-.516-2.45zM5.878 15.755l-1.788-.346.516 2.451zM2.152 12.512l.418-1.619H0zM8.824 19.322v-2.453l-1.837.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.878 15.755 4.606 17.86l2.521-.592z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.606 17.86a10.5 10.5 0 0 0 4.218 1.462l-1.697-2.054zM2.152 12.512l1.582 1.19a7 7 0 0 1-1.161-2.809zM3.73 13.701l.357 1.708 1.788.346a7.6 7.6 0 0 1-2.145-2.054M5.878 15.755l1.25 1.51 1.696-.399a7.8 7.8 0 0 1-2.946-1.111M11.18 19.322a10.4 10.4 0 0 0 4.211-1.457l-2.518-.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.12 15.755-1.247 1.513 2.519.595z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.12 15.755 1.27 2.108.517-2.449zM15.39 17.863a10.06 10.06 0 0 0 3.082-2.94l-2.565.494z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.269 13.706-.362 1.708 2.563-.49v-.003zM12.873 17.268l-1.692-.4v2.454zM20 10.893h-2.567l.418 1.755z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.27 13.706 2.2 1.215-.62-2.409zM18.47 14.92A9.4 9.4 0 0 0 20 10.89l-2.15 1.622zM12.872 17.268l1.245-1.51a7.75 7.75 0 0 1-2.94 1.108zM14.12 15.76l1.787-.341.362-1.709a7.7 7.7 0 0 1-2.15 2.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.27 13.706 1.58-1.194-.417-1.619a7.1 7.1 0 0 1-1.163 2.813M20 8.642a9.34 9.34 0 0 0-1.525-4.023l-.624 2.406zM16.272 5.834l1.578 1.191.625-2.409z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.272 5.834 2.203-1.218-2.565-.493zM18.475 4.616a10.05 10.05 0 0 0-3.077-2.944l.517 2.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.122 3.78 1.788.343-.511-2.451h-.005zM17.85 7.025l-.417 1.617H20zM11.18.213v2.455l1.835-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.122 3.78 1.272-2.108-2.521.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.394 1.672a10.4 10.4 0 0 0-4.218-1.46l1.697 2.054zM17.85 7.025l-1.58-1.19c.59.85.986 1.806 1.16 2.81zM16.271 5.834l-.359-1.709-1.788-.345a7.6 7.6 0 0 1 2.147 2.054M14.122 3.78l-1.25-1.511-1.696.4a7.7 7.7 0 0 1 2.946 1.11M10.002 3.914 8.207 6.882h3.59zM11.798 6.882l-1.795 2.972h3.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.588 9.852-1.79 2.97h3.586zM8.207 12.825l1.796-2.97h-3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.798 12.825 1.79-2.97h-3.585zM10.002 9.854l1.796-2.972H8.202zM6.412 9.854l-1.796 2.97h3.591zM10.002 3.914 8.207 6.882h3.59zM11.798 6.882l-1.795 2.972h3.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.588 9.852-1.79 2.97h3.586zM8.207 12.825l1.796-2.97h-3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.798 12.825 1.79-2.97h-3.585zM10.002 9.854l1.796-2.972H8.202zM6.412 9.854l-1.796 2.97h3.591zM3.73 13.701l.36 1.708-2.56-.493z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-token-airi_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconTokenAiri;